import { Skeleton } from "@mui/material";
import React from "react";

interface IProps {
  children?: React.ReactNode;
  title?: string;
  extraStyle?: React.CSSProperties;
  extraTextStyle?: React.CSSProperties;
  titleClass?: string;
  productDetailBoxDesign?: boolean;
  className?: string;
  viewContainerClass?: string;
  darkTitleBorder?: boolean;
  titleClassName?: string;
  loading?: boolean;
}
const BoxWrapper: React.FC<IProps> = ({
  children,
  title,
  extraStyle,
  extraTextStyle,
  titleClass,
  productDetailBoxDesign = false,
  className = "",
  viewContainerClass,
  darkTitleBorder = false,
  titleClassName,
  loading = false,
}) => {
  return (
    <div
      className={`w-full ${
        productDetailBoxDesign
          ? "bg-white rounded shadow-[0px_0px_6px_#00000029] border border-[#E6E6E6]"
          : "box-design"
      } ${className}`}
      style={{ ...extraStyle }}
    >
      <div
        className={`w-full px-4 2xl:px-6 py-2 2xl:py-3 border-b ${
          darkTitleBorder ? "border-[#707070]" : "border-gray-300"
        }  ${titleClass}`}
      >
        {title && !loading ? (
          <h2
            className={`${
              productDetailBoxDesign
                ? "font-Lexend-Medium font-size-25px text-[#3E3E3E]"
                : "font-Poppins-SemiBold font-size-20px text-[#004540]"
            } ${titleClassName} `}
            style={{ ...extraTextStyle }}
          >
            {title}
          </h2>
        ) : loading ? (
          <Skeleton
            variant="text"
            width="20%"
            height={"2.2vw"}
            className="rounded-md min-w-[60px] min-h-5"
          />
        ) : null}
      </div>
      <div
        className={`w-full px-4 2xl:px-6 py-2 2xl:py-4 ${viewContainerClass}`}
      >
        {children}
      </div>
    </div>
  );
};

export default BoxWrapper;
